import React, {Suspense, useState} from 'react';
import {Link} from "react-router-dom";
import {Outlet, useLocation} from "react-router-dom";
// import Footer from '../components/Footer';
import createLink from "../../libs/createLink";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {Button} from "../components/Button";
import EmailUnconfirmed from "../components2/EmailUnconfirmed/EmailUnconfirmed";
import _ from "lodash";
import {LoadingSuspense} from "../components/Loader";
import AnnouncementMessage from "../components2/announcementMessage/AnnouncementMessage";
import {useQuery} from "@tanstack/react-query";
import {USER_CURRENT_CLICK_CTA_KEY} from "../../api/public-voissa/users";
import useToken from "../../hooks/token";
import fnClickCta from "../../libs/clickCta";
import useCurrentUser from "../../queries/currentUser";
import AgeConfirmed from "../components/ageConfirmed/AgeConfirmed";
import { Helmet } from 'react-helmet';
import AppHeader from '../components2/AppHeader/AppHeader';
import Drawer from "../components2/Drawer/Drawer";
import DisclaimerOld from '../pages/disclaimer-old/DisclaimerOld';
import Disclaimer from '../pages/disclaimer/Disclaimer';
import useDisclaimer from '../../hooks/useDisclaimer';
import { useFeatureFlagVariantKey } from 'posthog-js/react';

const DisclaimerTest = ({initialized, disclaim})=>{
    const disclaimerVariant = useFeatureFlagVariantKey('disclaimer');
    return disclaimerVariant === 'new' ? (
        <Disclaimer initialized={initialized} disclaim={disclaim}/>
    ) : (
        <DisclaimerOld initialized={initialized} disclaim={disclaim}/>
    )
}

const Main = () =>{

    const location = useLocation();
    const [token] = useToken();
    const [toggleModalEmailUnconfirmed, setToggleModalEmailUnconfirmed] = useState(false);

    const {isSuccess : isSuccessCurrentUser,data : dataCurrentUser} = useCurrentUser({enabled : !!token});
    const { initialized, disclaim, showDisclaimer, hasAcceptedDisclaimer } = useDisclaimer({
        authorizedPaths: [
            createLink('cgus'),
            createLink('charter'),
            createLink('contact')
        ]
    });

    let currentUser = dataCurrentUser || {};
    let initUser = (!token || (isSuccessCurrentUser && !!token));

    useQuery(
        [USER_CURRENT_CLICK_CTA_KEY],
        ()=> fnClickCta(currentUser),
        {
            staleTime : ( 1000 * 60 * 2),
            enabled : !!_.get(currentUser,'_id'),
            placeholderData : fnClickCta(currentUser),
            //notifyOnChangeProps : ['data'],
        }
    );

    let showOnlyView = ([createLink("signin"), createLink("signup")].indexOf(location.pathname) === -1);

    return (
        <main className={`${!showOnlyView ? 'bgHeart' : ''}`}>
            <Helmet>
                <meta name="theme-color" content="#ffffff"/>
            </Helmet>
            <ToastContainer
                position="top-right"
                theme="dark"
                hideProgressBar={true}
                closeOnClick
                pauseOnVisibilityChange
                draggable
                pauseOnHover
            />
            {showDisclaimer && <DisclaimerTest initialized={initialized} disclaim={disclaim} />}
            <AppHeader initUser={initUser} hasAcceptedDisclaimer={hasAcceptedDisclaimer} />

            {initUser && !RegExp(`${createLink("messenger")}/*`).test(location.pathname) &&
                !RegExp(`chat-webcam`).test(location.pathname) &&
                <AnnouncementMessage role={_.get(currentUser,"role") || "guest"} />}

            {!RegExp(`/first-connexion`).test(location.pathname) && !RegExp(`/mon-profil/parametres/*`).test(location.pathname) ?  <AgeConfirmed /> : null}
            {
                !location.pathname.includes('first-connexion') && _.get(currentUser, "email.bounced")
                    ? (
                        <div className="alert-bar">
                            <span className="alert-bar-message">Votre adresse email semble invalide, <Link
                                to={createLink("userMeSettingsEmailAndPassword",currentUser)}>cliquez ici pour la modifier.</Link></span>
                        </div>
                    )
                    : null
            }
            {!location.pathname.includes('first-connexion') && _.get(currentUser,"role") === "emailUnconfirmed"
                ? (
                    <div className="alert-bar" onClick={() => setToggleModalEmailUnconfirmed(true)}>
                        <span className="alert-bar-message">
                            Merci de confirmer votre email afin de pouvoir utiliser toutes les
                        fonctionnalités du site
                        </span>
                        <Button className="danger"
                                size={"small"}
                                content="Confirmer"/>
                    </div>
                ) : null}

            {isSuccessCurrentUser ? (
                    <Drawer
                        open={toggleModalEmailUnconfirmed}
                        headContent="Confirmer votre email"
                        handleClose={() => setToggleModalEmailUnconfirmed(false)}
                        small
                    >
                        <EmailUnconfirmed toggle={toggleModalEmailUnconfirmed} />
                    </Drawer>
            ) : null}

            <div id="view" >
                {initUser ? (
                    <Suspense fallback={<LoadingSuspense />}>
                        <Outlet context={{currentUser, isSuccessCurrentUser}} />
                    </Suspense>
                ) : (
                    <LoadingSuspense />
                )}

            </div>

            {/* {
                !RegExp(`chat-webcam`).test(location.pathname) &&
                 showOnlyView && location.pathname !== createLink("actuality") &&
                <Footer />} */}
        </main>
    )
}

export default Main;